<template>
  <div class="history-item">
    <div class="prize-item-img" :class="`prize-item-img-${$bus.mapShopIndexToShopType(item.shop)}`">
      <img
        :src="item.item_img"
        alt="prize"
      />
      <PrizeNum :num="item.item_num" />
    </div>
    <div class="history-item-name">
      <p v-marquee><span class="history-item-name-text">{{ item.item_name }}</span></p>
    </div>
    <div class="history-item-shop">{{ $bus.mapShopIndexToShopName(item.shop) }}</div>
    <div class="history-item-cost">
      <span class="diamond"></span>
      <div class="history-item-cost-value">{{ Math.floor(item.price * (100 - item.discount) / 100) }}</div>
    </div>
    <div class="history-item-discount">{{ item.discount }}% {{ $bus.transify['FESTA_BUTTON_DISCOUNT'] }}</div>
    <div class="history-item-time">{{ formatTime(item.created) }}</div>
  </div>
</template>

<script>
import PrizeNum from '@/components/business-base/prize-num'
import { getTime } from '@/utils/assist'

export default {
  props: {
    item: Object
  },
  components: {
    PrizeNum
  },
  methods: {
    formatTime (time) {
      return getTime(time)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-item {
  @include flexac;
  width: 100%;
  @include px2res(height, 126);
  @include px2res(padding, 10, 0);
  @include px2res(border-bottom-width, 1);
  border-bottom-style: solid;
  border-bottom-color: #D58A40;

  .prize-item-img {
    position: relative;
    @include flexrc;
    @include px2res(width, 97);
    @include px2res(height, 94);
    @include px2res(min-width, 97);
    @include px2res(min-height, 94);

    img {
      max-width: 75%;
      max-height: 75%;
    }
  }

  .history-item-name {
    @include px2res(width, 90);
    @include px2res(margin-left, 16);
    @include px2res(margin-right, 20);
    overflow: hidden;
    font-weight: 300;
    font-family: $main-font-family;
    @include px2res(font-size, 24);

    p {
      overflow: hidden;
      text-align: center;
      white-space: nowrap;
    }

    .history-item-name-text {
      font-weight: 300;
      font-family: $main-font-family;
      @include px2res(font-size, 24);
    }
  }

  .history-item-shop {
    @include px2res(width, 120);
    text-align: center;
    font-weight: 300;
    font-family: $main-font-family;
    @include px2res(font-size, 24);
  }

  .history-item-cost {
    @include flexac;
    /* @include px2res(margin-left, 12); */
    @include px2res(width, 110);
    /* @include px2res(margin-right, 27); */

    .diamond {
      @include px2res(width, 28);
      @include px2res(height, 25);
    }

    .history-item-cost-value {
      /* @include px2res(width, 72); */
      @include px2res(padding-left, 5);
      font-weight: 300;
      font-family: $main-font-family;
      @include px2res(font-size, 24);
    }
  }

  .history-item-discount {
    @include px2res(width, 90);
    /* @include px2res(margin-right, 19); */
    font-weight: 300;
    font-family: $main-font-family;
    @include px2res(font-size, 24);
    text-align: center;
  }

  .history-item-time {
    text-align: center;
    font-weight: 300;
    font-family: $main-font-family;
    @include px2res(font-size, 24);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/history/item.vue